import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const SupportChat = {
  Helmet: lazyNamed(() => import('./Helmet.tsx'), 'Helmet'),
  Chat: lazyNamed(() => import('./pages/Chat/index.tsx'), 'SupportChat'),
};
